import { render, staticRenderFns } from "./MealCard.vue?vue&type=template&id=8ae4b2f4&lang=pug&"
import script from "./MealCard.vue?vue&type=script&lang=js&"
export * from "./MealCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports